import { Routes, Route } from 'react-router-dom';
import BeneficiarySearch from '../modules/e-opd/Components/BeneficiarySearch';
import OpdStepperWrapper from '../modules/e-opd/Components/OpdStepper/OpdStepperWrapper';
import VisitSummary from '../modules/e-opd/Components/OpdStepper/VisitSummary/VisitSummary';
import PatientVisitHistory from '../modules/e-opd/Components/VisitHistory/PatientVisitHistory';

const EOPDRoutes = () => {
  return (
    <Routes>
      <Route path="/beneficiary" element={<BeneficiarySearch />} />
      <Route path="/registration" element={<OpdStepperWrapper />} />
      <Route path="/visit-summary/:displayId" element={<VisitSummary />} />
      {/* Patient id URL me nahi — sirf beneficiary list ke view icon se router
          state ke through aata hai (PatientVisitHistory bina state ke redirect
          kar deta hai). */}
      <Route path="/visit-history" element={<PatientVisitHistory />} />
    </Routes>
  );
};

export default EOPDRoutes;
